import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
import { NavDropdown, MenuItem } from "components/bootstrap";
import useHotkeysContext from "hooks/useHotkeysContext";
import NavIcon from "components/navigation/NavIcon";
import usePermissions from "hooks/usePermissions";
const HelpMenu = () => {
  const { setShowHotkeysModal } = useHotkeysContext();
  const menuItems = usePluginEntities("helpMenu");
  const { isPermitted } = usePermissions();
  const availableMenuItems = menuItems.filter((item) => isPermitted(item.permissions));
  return /* @__PURE__ */ React.createElement(NavDropdown, { title: /* @__PURE__ */ React.createElement(NavIcon, { type: "help" }), hoverTitle: "Help", noCaret: true }, availableMenuItems.map((item) => {
    if ("externalLink" in item) {
      return /* @__PURE__ */ React.createElement(MenuItem, { key: item.description, component: "a", href: item.externalLink, target: "_blank", icon: "open_in_new" }, item.description);
    }
    if ("path" in item) {
      return /* @__PURE__ */ React.createElement(MenuItem, { key: item.description, component: "a", href: item.path }, item.description);
    }
    if ("action" in item) {
      return /* @__PURE__ */ React.createElement(
        MenuItem,
        {
          key: item.description,
          onClick: () => item.action({ showHotkeysModal: () => setShowHotkeysModal(true) })
        },
        item.description
      );
    }
    throw Error("Help menu item must have either external link, path, or action defined");
  }));
};
export default HelpMenu;
